export const newsDateUK = state => state.news.newsDate.newsDateUK;
export const newsDateRU = state => state.news.newsDate.newsDateRU;
export const newsDateErrorUK = state => state.news.newsDate.newsDateErrorRU;
export const newsDateErrorRU = state => state.news.newsDate.newsDateErrorRU;
export const newsDateLoading = state => state.news.newsDate.loading;
export const newsDatePageNumberUK = state =>
  state.news.newsDate.newsDatePageNumberUK;
export const newsDatePageNumberRU = state =>
  state.news.newsDate.newsDatePageNumberRU;
